import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const appointmentErrorTypeValues = [
  "FREEBUSY_CALENDAR_ERROR",
  "APPOINTMENT_SLOT_UNAVAILABLE",
  "APPOINTMENT_SLOT_OFF_GRID",
  "APPOINTMENT_SLOT_OUTSIDE_WORKING_HOURS",
  "NOT_A_FIELD_SALES_REP",
  "CALENDAR_EVENT_INSERT_RETURNED_NO_ID",
] as const;
const appointmentErrorTypeSchema = z.enum(appointmentErrorTypeValues);
export const AppointmentErrorType = appointmentErrorTypeSchema.enum;
type AppointmentErrorType = z.infer<typeof appointmentErrorTypeSchema>;

export type AppointmentErrors =
  | {
      errorType: typeof AppointmentErrorType.FREEBUSY_CALENDAR_ERROR;
      data: { reasons: string[] };
    }
  | {
      errorType: typeof AppointmentErrorType.APPOINTMENT_SLOT_UNAVAILABLE;
      data: { start: string; reason: "WITHIN_MIN_LEAD" | "BUSY" };
    }
  | {
      errorType: typeof AppointmentErrorType.APPOINTMENT_SLOT_OFF_GRID;
      data: { start: string };
    }
  | {
      errorType: typeof AppointmentErrorType.APPOINTMENT_SLOT_OUTSIDE_WORKING_HOURS;
      data: { start: string };
    }
  | {
      errorType: typeof AppointmentErrorType.NOT_A_FIELD_SALES_REP;
      data: { personId: string };
    }
  | {
      errorType: typeof AppointmentErrorType.CALENDAR_EVENT_INSERT_RETURNED_NO_ID;
      data: undefined;
    };

export const appointmentErrorDetails: Record<AppointmentErrorType, ErrorDetails> = {
  FREEBUSY_CALENDAR_ERROR: {
    classification: ErrorClassification.INTEGRATION_ERROR,
    sentryDescription: "Google returned an error instead of availability for a calendar",
  },
  APPOINTMENT_SLOT_UNAVAILABLE: {
    classification: ErrorClassification.CONFLICT_ERROR,
    sentryDescription: "Appointment slot is no longer free on a participant calendar",
  },
  APPOINTMENT_SLOT_OFF_GRID: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Appointment start is not on the slot grid",
  },
  APPOINTMENT_SLOT_OUTSIDE_WORKING_HOURS: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Appointment falls outside the market's working hours",
  },
  NOT_A_FIELD_SALES_REP: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Person is not an active member of the field sales team",
  },
  CALENDAR_EVENT_INSERT_RETURNED_NO_ID: {
    classification: ErrorClassification.INTEGRATION_ERROR,
    sentryDescription: "Google Calendar events.insert succeeded without returning an event id",
  },
};
